module.exports = __webpack_public_path__ + "img/token-icon.e88295ab.svg";